import { Component, HostListener, OnInit } from '@angular/core';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private theme: ThemeService) {}

  @HostListener('window:scroll', ['$event'])
  beforeUnloadHandler() {

    localStorage.setItem('scrollPosition', JSON.stringify({
      x: 0,
      y: window.scrollY
    }));
  }

  ngOnInit() {
    this.theme.loadCurrentTheme();
    setTimeout(() => {
      // console.clear();
    }, 200);
  }
}
